export const DEMO_TAG_COLOR = '#256FEB';
export const DEMO_TAG_TEXT = 'Demo';
